/* tslint:disable:no-string-literal */
import {Injectable} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import {ISelection, IGlossaryEntry, IDictionaryEntry,
    IText, ISentence, IWord, IMetaData} from "../../api/data-model";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {HttpClient} from "@angular/common/http";
import {parse} from "himalaya";
import {Scilearn} from "../../constants";

@Injectable()
export class WordCategoryPipelineService {
    private glueWordLists: object;

    constructor(
        private logService: BugsnagLoggingService,
        private http: HttpClient
    ) {
        this.http.get("assets/batchprocess/word-category/gluewords.json", {
            responseType: "json"
        }).subscribe((response: any) => {
            this.glueWordLists = response;
        });
    }

    public assignWordCategory(selection: ISelection) {
        const ATOS = selection.metaData?.ATOSGradeEquivalent;
        selection.text.forEach((text) => {
            if (text.sentences) {
                text.sentences.forEach((sentence) => {
                    this.processWordCategory(sentence, ATOS);
                });
            }
        });
    }

    private processWordCategory(sentence: ISentence, ATOS: string): ISentence {

        // not dealing with sentence position or in-a-row rules yet
        sentence.words.forEach((word: IWord) => {
            // 'Special' lenient pronunciation category is manually applied, so don't override
            if (word.category !== Scilearn.WORD_CATEGORY_SPECIAL) {
                word.category = this.wordCategory(word.dictionary ? word.dictionary[0] : word.word, ATOS);
            }
        });
        // check for 3+ in a row glue words and unglue one
        for (let i = 0; i < sentence.words.length - 2; i++) {
            if (sentence.words[i].category === Scilearn.WORD_CATEGORY_GLUE &&
                sentence.words[i + 1].category === Scilearn.WORD_CATEGORY_GLUE &&
                sentence.words[i + 2].category === Scilearn.WORD_CATEGORY_GLUE) {
                let scoreFirst: number = this.scoreGlue(sentence.words[i].word);
                let scoreMiddle: number = this.scoreGlue(sentence.words[i + 1].word);
                let scoreLast: number = this.scoreGlue(sentence.words[i + 2].word);
                let max: number = Math.max(scoreFirst, scoreMiddle, scoreLast);
                // in case of ties prefer to unglue middle, then first, then last
                if (scoreMiddle === max) {
                    sentence.words[i + 1].category = Scilearn.WORD_CATEGORY_DEFAULT;
                }
                else if (scoreFirst === max) {
                    sentence.words[i].category = Scilearn.WORD_CATEGORY_DEFAULT;
                }
                else {
                    sentence.words[i + 2].category = Scilearn.WORD_CATEGORY_DEFAULT;
                }

            }
        }
        // finally, check for glossary entry words and make them target category, unless they are glue
        sentence.words.forEach((word) => {
            word.category = !!word.glossary && word.category !== Scilearn.WORD_CATEGORY_GLUE
                ? Scilearn.WORD_CATEGORY_TARGET : word.category;
        });
        return sentence;

    }


    private scoreGlue(wordString: string): number {
        // higher score to words which only appear on the higher reading level lists
        let score = this.glueWordLists["lists"].length; // if we don't find it on any list, should not be glue
        this.glueWordLists["lists"].forEach((list, index) => {
            if (list["words"].indexOf(wordString.toLowerCase()) >= 0) {
                score = index;
            }
        });

        return score;
        return 1;

    }

    private wordCategory(wordString: string, ATOS: string): string {
        let category = Scilearn.WORD_CATEGORY_DEFAULT;
        // find which word list to use based on reading level
        let grade: string = ATOS.trim().split(".")[0];
        this.glueWordLists["lists"].forEach((list) => {
            if (list["readingLevels"].indexOf(grade) >= 0) {
                if (list["words"].indexOf(wordString.toLowerCase()) >= 0) {
                    category = Scilearn.WORD_CATEGORY_GLUE;
                }
            }

        });
        return category;
    }

}
